module.exports = __webpack_public_path__ + "static/img/billManagement.686b9c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/billManagement.png
// module id = naM+
// module chunks = 21